'use strict';

// UTM Tracking functionality
const UTMTracking = (() => {
  const getUTMParameters = () => {
    const params = {};
    window.location.search.substring(1).split('&').forEach((param) => {
      const pair = param.split('=');
      if (pair[0].startsWith('utm_')) {
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
    });
    return params;
  };

  // Store UTM parameters in Local Storage for later use
  const storeUTMParameters = () => {
    const utmParams = getUTMParameters();
    Object.keys(utmParams).forEach(param => {
      localStorage.setItem(param, utmParams[param]);
    });
  };

  return {
    init: () => {
      document.addEventListener('DOMContentLoaded', () => {
        storeUTMParameters();
      });
    },
    getUTMParamsFromLocalStorage: () => {
      const utmParams = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
        const value = localStorage.getItem(param);
        if (value) {
          utmParams[param] = value;
        }
      });
      return utmParams;
    }
  };
})();

export default UTMTracking;
